import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EventToolbox } from 'client/utils/event-toolbox';
import { NAV_LIST_CUSTOM_EVENT } from 'site-modules/comparator/constants/comparator';
import { AnchorNavContent } from 'site-modules/shared/components/anchor-nav-sticky/anchor-nav-content';

import './comparator-anchor-nav.scss';

export function ComparatorAnchorNav({ list = null, customOffset = undefined, ariaLabel }) {
  const [displayList, setDisplayList] = useState(null);

  useEffect(() => {
    function updateDisplayList({ detail: { navListItems } }) {
      setDisplayList(navListItems);
    }

    EventToolbox.on(NAV_LIST_CUSTOM_EVENT, updateDisplayList);

    return () => EventToolbox.off(NAV_LIST_CUSTOM_EVENT, updateDisplayList);
  }, []);

  const displayNavList = (displayList?.length ? list.filter(({ hash }) => displayList.includes(hash)) : list).map(
    navItem => ({ ...navItem, customOffset: customOffset * -1 })
  );

  return (
    <div className="comparator-anchor-nav">
      <AnchorNavContent navList={displayNavList} ariaLabel={ariaLabel} isMobile />
      <hr className="my-0 row" />
    </div>
  );
}

ComparatorAnchorNav.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      hash: PropTypes.string,
    })
  ),
  ariaLabel: PropTypes.string.isRequired,
  customOffset: PropTypes.number,
};
